import React from 'react'
import PropTypes from 'prop-types'

import { TASK_TYPES } from '../../../../tasks/constants'

const MaxAssignedDefinitionTaskLimitReachedErrorDescription = ({
  taskTypes,
  userId,
}) => {
  return (
    <div>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>
        Max assigned definition tasks limit reached.
      </div>
      <div style={{ marginBottom: 8 }}>
        Please resolve the currently assigned tasks before assigning a new one.
      </div>
      <div style={{ marginBottom: 4 }}>See the following links:</div>
      <ul style={{ marginTop: 0, marginBottom: 0, paddingLeft: 20 }}>
        {taskTypes.map(taskType => {
          const taskTypeItem =
            TASK_TYPES[taskType] ||
            (Array.isArray(TASK_TYPES)
              ? TASK_TYPES.find(item => item.value === taskType)
              : null)
          if (!taskTypeItem) return null
          return (
            <li key={taskType}>
              <a
                href={`/tasks/${taskTypeItem.key}?page=1&isAssigned=true&assignedToId=${userId}&isAwaiting=false`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {taskTypeItem.name} tasks
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

MaxAssignedDefinitionTaskLimitReachedErrorDescription.propTypes = {
  taskTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  userId: PropTypes.string.isRequired,
}

export default MaxAssignedDefinitionTaskLimitReachedErrorDescription
